import { createAsyncThunk } from '@reduxjs/toolkit'
import GenericResult from './generic-result-model'
import {
  delete_genericResult,
  load_genericResults,
  store_genericResult,
} from './genericResult-service'

export const LoadGenericResultsAsync = createAsyncThunk<any, any>(
  'composer/load/genericResult',
  async (params: { uid: string }) => {
    return await load_genericResults(params)
  },
)

export const CreateGenericResultAsync = createAsyncThunk<any, any>(
  'composer/create/genericResult',
  async (params: GenericResult) => {
    return await store_genericResult(params)
  },
)

export const DeleteGenericResultAsync = createAsyncThunk<any, any>(
  'composer/delete/genericResult',
  async (params) => {
    return await delete_genericResult(params)
  },
)
